import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaIndustry } from 'react-icons/fa';
import './Contacts.css';

const contacts = [
  {
    id: 1,
    icon: <FaPhone />,
    title: 'Телефон',
    value: '+7 812 237-38-34',
    link: 'tel:+78122373834'
  },
  {
    id: 2,
    icon: <FaEnvelope />,
    title: 'Email',
    value: 'agoratech@mail.ru',
    link: 'mailto:agoratech@mail.ru'
  },
  {
    id: 3,
    icon: <FaMapMarkerAlt />,
    title: 'Адрес склада',
    value: '196158, Россия, г. Санкт-Петербург, Московское шоссе, 23АБ',
    link: null
  },
  {
    id: 4,
    icon: <FaIndustry />,
    title: 'Адрес производства',
    value: 'г. Нижний Новгород, пос. Черепичный, 2а',
    link: null
  }
];

const Contacts = () => {
  return (
    <section id="contacts" className="contacts-section">
      <div className="container-custom">
        <div className="contacts-grid">
          {contacts.map((contact) => (
            <div key={contact.id} className="contact-card">
              <div className="contact-icon">
                {contact.icon}
              </div>
              <h3 className="contact-title">{contact.title}</h3>
              {contact.link ? (
                <a href={contact.link} className="contact-value contact-link" draggable={false}>
                  {contact.value}
                </a>
              ) : (
                <span className="contact-value">{contact.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contacts;
